import { render, staticRenderFns } from "./PracticalResearchOutcome.vue?vue&type=template&id=510807ca&scoped=true"
import script from "./PracticalResearchOutcome.vue?vue&type=script&lang=js"
export * from "./PracticalResearchOutcome.vue?vue&type=script&lang=js"
import style0 from "./PracticalResearchOutcome.vue?vue&type=style&index=0&id=510807ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510807ca",
  null
  
)

export default component.exports